// extracted by mini-css-extract-plugin
export default {"main":"NoMatchPage_main__rvGaN","text":"NoMatchPage_text__w4d6y","link":"NoMatchPage_link__KHqe1"};